import { types } from "../actions/formPurchasableFar";

const initialState = {
  checklistReview: {},
};

const checklistReviewReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.UPDATE_CHECKLIST_REVIEW:
      return {
        ...state,
        checklistReview: { ...state.checklistReview, ...action.payload },
      };
    default:
      return state;
  }
};

export default checklistReviewReducer;
